// Turns the answer of api/Export/CatureSSNode into the thumbnail's link relative to the API
// ("Assets/ExportedImages/<user>/<project>/<slide>/<file>.jpg").
// Newer APIs send it as `path`; older ones only send the server's file path inside `_filePath`,
// which used to be cut at "API\" (Windows only, and broke when the API folder had another name).
export function thumbnailPathFrom(data) {
  if (!data || data.status === false) throw new Error("The server could not create the thumbnail.");
  if (data.path) return String(data.path).replace(/^\/+/, "");
  const parsed = typeof data._filePath === "string" ? JSON.parse(data._filePath) : data._filePath;
  const full = String((parsed && parsed.filePath) || "").replace(/\\/g, "/");
  const at = full.search(/(^|\/)Assets\//i);
  if (at < 0) throw new Error("Unexpected thumbnail path: " + full);
  return full.slice(full[at] === "/" ? at + 1 : at);
}
